const ITEMS = [
  "TROCA DE TELA COM GARANTIA",
  "REPARO DE PLACA",
  "BATERIA 100% SAÚDE",
  "RECUPERAÇÃO DE APARELHO MOLHADO",
  "CONECTOR USB-C & LIGHTNING",
  "ORÇAMENTO SEM COMPROMISSO",
  "GARANTIA DOCUMENTADA",
  "AV. SÃO BORJA 412 - SÃO LEOPOLDO",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="bg-[#2E373E] border-y border-white/10 py-4 overflow-hidden"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {row.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="font-mono-tech text-xs uppercase tracking-[0.25em] text-zinc-400 mx-6 flex items-center gap-6"
          >
            <span className="text-[#99BA4B]">•</span>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
